import auth from '@client/components/auth';
import { useCallback, useEffect } from 'react';
import { useUser } from '../hooks/use-user';
import { LayoutBase } from '@design-system/components/layouts/layoutBase';
import { CreatorMenu } from './CreatorMenu';
import Intercom from '@intercom/messenger-js-sdk';
import { toImgSrcRaw } from '@client/pages/CustomProgramPage/helpers';
import { CircularProgress } from '@mui/material';

export const CreatorLayout = (p: React.PropsWithChildren) => {
  const { influencer, logout, customizations, loading } = useUser();

  useEffect(() => {
    if (influencer?.id) {
      Intercom({
        app_id: import.meta.env.VITE_INTERCOM_WORKSPACE,
        user_id: `${influencer.id}`,
        name: `${influencer.firstName} ${influencer.lastName}`,
        email: influencer.email || '',
        created_at: influencer.createdAt || new Date().getTime(),
        username: influencer.title,
        avatar: {
          type: 'avatar',
          image_url: toImgSrcRaw(influencer.mediaAvatar),
        },
      });
    }
  }, [influencer]);

  const onLogout = useCallback(() => {
    auth.logout();
    logout();
    // TODO: remove that when new routing is introduced
    window.location.reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  if (!influencer) {
    onLogout();
    return null;
  }

  return (
    <>
      <LayoutBase
        menu={
          <CreatorMenu
            onLogout={onLogout}
            customizations={customizations}
            influencer={influencer}
          />
        }
      >
        {p.children}
      </LayoutBase>
    </>
  );
};
